import * as THREE from 'three';
import { generalCalculationDefaultOptions } from '../general-calculation';

const options = JSON.parse(JSON.stringify(generalCalculationDefaultOptions));

delete options.animate;

export default {
  ...options,

  name: 'bracket-attachment',

  camera2D: {
    position: new THREE.Vector3(10, 0, 0)
  }
};



// WEBPACK FOOTER //
// ./src/object-view/generators/bracket-attachment/defaultOptions.js